import { useCallback, useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { SCROLL_TO_TOP_THRESHOLD } from "../lib/constants";

export function ScrollToTop() {
    // Initial visibility is derived synchronously so the button doesn't
    // flicker if the page is loaded already scrolled. The effect then
    // only attaches the listener (no synchronous setState in effect).
    const [visible, setVisible] = useState(
        () =>
            typeof window !== "undefined" &&
            window.scrollY > SCROLL_TO_TOP_THRESHOLD,
    );

    const onScroll = useCallback(() => {
        setVisible(window.scrollY > SCROLL_TO_TOP_THRESHOLD);
    }, []);

    useEffect(() => {
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [onScroll]);

    return (
        <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Revenir en haut de la page"
            data-testid="scroll-to-top"
            className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-[#0B132B] text-[#F9F9F8] rounded-full shadow-sm hover:bg-[#1B4332] transition-all duration-300 ${
                visible
                    ? "opacity-100 translate-y-0 pointer-events-auto"
                    : "opacity-0 translate-y-3 pointer-events-none"
            }`}
        >
            <ArrowUp className="w-5 h-5" />
        </button>
    );
}
